import React, { useState } from 'react';

import { UpgradeModal } from '../../components/BillingModal';
import { useAuth } from '../../context/AuthContext';
import { normalizePlanTier } from '../../utils/planDisplay';

import './LoopCreationOptions.css';

export const useLoopWatermarkPermission = () => {
  const { user } = useAuth();

  return Boolean(user && normalizePlanTier(user.subscription_tier) !== 'free'
    && ['active', 'cancel_pending'].includes((user.subscription_status || 'active').toLowerCase()));
};

export const LoopWatermarkToggle: React.FC<{
  value: boolean; onChange: (value: boolean) => void; disabled?: boolean; compact?: boolean;
}> = ({ value, onChange, disabled, compact = true }) => {
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const paid = useLoopWatermarkPermission();
  const enabled = !paid || value;
  const toggle = () => {
    if (enabled && !paid) setUpgradeOpen(true);
    else onChange(!enabled);
  };

  return <>
    <div className={`loop-recording-option${compact ? ' loop-recording-option--compact' : ''}`}>
      <button type="button" role="switch" aria-checked={enabled} aria-label="Loop watermark"
        className={`loop-recording-switch${enabled ? ' is-on' : ''}`} disabled={disabled}
        title={'Adds “looped by https://8080.ai” to posts, comments, messages, reels, stories and TikToks. Paid plans can turn it off.'}
        onClick={toggle}>
        <span className="loop-recording-switch__track" aria-hidden="true"><span /></span>
        <span>Watermark</span>
      </button>
    </div>
    {upgradeOpen && <UpgradeModal source="loops:watermark" onClose={() => setUpgradeOpen(false)}
      subtitle="Upgrade to remove “looped by https://8080.ai” from your Loop’s posts, comments and messages." />}
  </>;
};
